import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { BellRing, Trash2 } from "lucide-react";
import { useApi, errMsg } from "@/lib/api";

export const MyAlerts = () => {
  const call = useApi();
  const [alerts, setAlerts] = useState(null);
  const load = useCallback(() => call("get", "/alerts/mine").then((r) => setAlerts(r.data)).catch(() => setAlerts([])), [call]);
  useEffect(() => { load(); }, [load]);

  const remove = async (id) => {
    try { await call("delete", `/alerts/${id}`); toast.success("Aviso cancelado"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <section className="mt-12" data-testid="my-alerts">
      <h2 className="filter-title flex items-center gap-2"><BellRing className="w-4 h-4" /> Mis avisos de talla</h2>
      {alerts?.length === 0 && <p className="text-sm text-slate-500 border border-dashed p-6" data-testid="alerts-empty">No tienes avisos. En cualquier producto, pulsa una talla agotada y pide que te avisemos.</p>}
      <div className="bg-white border divide-y empty:hidden">
        {alerts?.map((a) => (
          <div key={a.id} className="p-4 flex items-center gap-4 text-sm" data-testid={`alert-${a.id}`}>
            <Link to={`/producto/${a.product_id}`} className="flex-1 min-w-0 hover:text-brand">
              <p className="font-semibold truncate">{a.product_name}</p>
              <p className="text-xs text-slate-500">Talla {a.size}{a.color && ` · ${a.color}`}</p>
            </Link>
            {a.status === "sent"
              ? <span className="tag bg-emerald-100 text-emerald-700">Avisado</span>
              : <span className="tag bg-amber-100 text-amber-700">Esperando stock</span>}
            <button onClick={() => remove(a.id)} className="p-2 text-slate-400 hover:text-rose-600" data-testid={`alert-delete-${a.id}`} aria-label="Cancelar aviso"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
    </section>
  );
};
